/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.18.1@lodash/_freeGlobal.js
// module id = 527
// module chunks = 0